import { createSignal } from "solid-js";

/**
 * Top-level connection state. Set by createMetricStream and read by
 * the StatusStrip indicator so the operator can see at a glance
 * whether the WebSocket is healthy.
 */
export const [connected, setConnected] = createSignal(false);
